import { createNodeDef } from "../../nodes.helpers";
import { DataFieldType } from "src/types/data-field.types";
import { randFirstName } from "@ngneat/falso";

type Options = Exclude<Parameters<typeof randFirstName>[0], undefined>;
type Gender = Exclude<Options["gender"], undefined> | "";

const genders: Record<Gender, string> = {
  "": "",
  female: "female",
  male: "male",
};

export const randFirstNameNodeDef = createNodeDef({
  type: "randFirstName",
  displayName: "First Name",
  defaultName: "firstName",
  fields: [
    { type: DataFieldType.BOOLEAN, key: "withAccents", label: "Accents" },
    {
      type: DataFieldType.SELECT,
      key: "gender",
      label: "Gender",
      options: genders,
    },
  ],
  initialData: (): { withAccents: boolean; gender: Gender } => ({
    withAccents: true,
    gender: "",
  }),
  generate: ({ node }) => {
    return randFirstName({
      withAccents: node.data.withAccents,
      gender: node.data.gender || undefined,
    });
  },
});
